export default {
  header: 'Wir müssen deine Telefonnummer verifizieren',
  buttons: {
    confirm: 'Bestätigen',
  },
  toasts: {
    invalid_code: 'Ungültiger Code. Bitte versuche es erneut.',
  },
};
